import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getPickupLocationCountries } from 'stores/userSlice';

const useInternationalOrderCheck = ({ orderCountryCode, pickupLocationCountryCode }) => {
	const dispatch = useDispatch();
	const pickupLocationCountries = useSelector((state) => state.user.pickupLocationCountries);

	useEffect(() => {
		if (!pickupLocationCountries) {
			dispatch(getPickupLocationCountries());
		}
	}, []);

	const isInternationalOrder = useMemo(() => {
		if (pickupLocationCountryCode) {
			return orderCountryCode !== pickupLocationCountryCode;
		} else if (pickupLocationCountries) {
			return !pickupLocationCountries.includes(orderCountryCode);
		} else {
			return false;
		}
	}, [orderCountryCode, pickupLocationCountryCode, pickupLocationCountries]);

	return { isInternationalOrder };
};

export default useInternationalOrderCheck;
